export default [
  {
    path: "/general-services",
    name: "general-services",
    component: () => import("@/views/general-services/GeneralServicesView.vue"),
    meta: {
      activeIcon: "General Services",
      routeName: "General Services",
    },
  },
  {
    path: "/general-services/:id",
    name: "general-services-details",
    component: () =>
      import(
        /* webpackChunkName: "general-services" */ "@/views/general-services/GeneralServiceInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "General Service Information",
    },
  },
  {
    path: "/general-services/:id/files/:hospital_service_id",
    name: "general-services-files",
    component: () =>
      import(
        /* webpackChunkName: "general-services" */ "@/views/general-services/GeneralServiceFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "General Service Files",
    },
  },
  {
    path: "/general-services/:id/files/:hospital_service_id/viewer",
    name: "general-services-files-view",
    component: () =>
      import(/* webpackChunkName: "general-services" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "General Service File Viewer",
    },
  },
];
